import { render, staticRenderFns } from "./default.vue?vue&type=template&id=06a04b68&scoped=true"
var script = {}
import style0 from "./default.vue?vue&type=style&index=0&id=06a04b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a04b68",
  null
  
)

export default component.exports